/* eslint-disable @next/next/no-img-element */
import DefaultPageLayout from "@/layouts/DefaultPageLayout";
import { Divider, Skeleton } from "@nextui-org/react";
import clsx from "clsx";
import VerticalGradientText from "../VerticalGradientText";
import { useGlobalData } from "@/contexts/GlobalData";
import PrimaryButton from "../PrimaryButton";
import DynamicFontSize from "../DynamicFontSize";
import DynamicSizeIcon from "../DynamicSizeIcon";
import Link from "next/link";
import DepositFunction from "../DepositFunction";
function PortfolioLoading() {
  const prefix = "portfolio_";
  const {
    translate,
    getIcon,
    portfolioData,
    getImageFromCMS,
    userWallets
  } = useGlobalData();
  const isCanAccessPersonal = !!userWallets?.balances?.find((token: any) => !!+token.balance);
  return <DefaultPageLayout className="flex flex-col gap-2" data-sentry-element="DefaultPageLayout" data-sentry-component="PortfolioLoading" data-sentry-source-file="index.tsx">
            <div id="checkPage" className="">
                <DynamicFontSize fontSize={32} data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    <VerticalGradientText className="flex mt-[calc(27/812*100vh)] flex-col animate-fade-up animate-duration-[1200ms]" data-sentry-element="VerticalGradientText" data-sentry-source-file="index.tsx">
                        <span className="custom-text-color text-secondary font-semibold">
                            {translate(prefix + "Portfolio")}
                        </span>
                        <span>{translate(prefix + "summarizes your")}</span>
                        <span>{translate(prefix + "investments and")}</span>
                        <span>{translate(prefix + "lets you monitor")}</span>
                        <span>{translate(prefix + "your assets ")}</span>
                        <span>{translate(prefix + "easily.")}</span>
                    </VerticalGradientText>
                </DynamicFontSize>

                {portfolioData && !!userWallets && !userWallets?.isOpenPortfolio && <DepositFunction className="relative z-10">
                        <PrimaryButton className={clsx(" flex items-center justify-center animate-fade-right animate-duration-1000 animate-delay-[200ms] mt-3")}>
                            <div className="flex p-4 gap-2">
                                <DynamicFontSize className="" fontSize={16}>
                                    {translate(prefix + "Invest Now")}
                                </DynamicFontSize>
                                {/* <DynamicSizeIcon icon={getIcon(prefix + "invest_now")} width={16} /> */}
                            </div>
                        </PrimaryButton>
                    </DepositFunction>}
                <img src={getImageFromCMS("portfolio-loading-image")} alt="" className="h-[45vh] absolute -bottom-[23vh] -right-[1vw] mix-blend-screen" />
            </div>
        </DefaultPageLayout>;
}
export default PortfolioLoading;